<template>
  <v-dialog v-model="dialog" max-width="1100" persistent>
    <v-card>
      <v-card-title>
        <span class="headline">Invoices</span>
      </v-card-title>
      <v-card-text>
        <reconciliation-detail-ar :items="items" v-if="type === 'AR'"></reconciliation-detail-ar>
        <reconciliation-detail-ap :items="items" v-if="type === 'AP'"></reconciliation-detail-ap>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" text @click="close">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ReconciliationDetailAr from "./ReconciliationDetailAr.vue";
import ReconciliationDetailAp from "./ReconciliationDetailAp.vue";

export default {
  name: "reconciliation-detail",
  components: {
    ReconciliationDetailAr,
    ReconciliationDetailAp,
  },
  props: {
    dialog: Boolean,
    items: Array,
    type: String,
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style></style>
